import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["caffeine-and-running"]!;

export function Body() {
  return (
    <>
      <p>
        Coffee before a race is a habit for many runners. Caffeine is also one of the best
        studied aids to performance. How much does it help, and how much do you need?
      </p>

      <h2>What the researchers did</h2>
      <p>
        An umbrella review from 2020 collected 21 meta-analyses from 11 reviews of caffeine and
        exercise performance. A position stand from the International Society of Sports
        Nutrition in 2021 summarised the research on dose, timing and individual differences.
      </p>

      <h2>What they found</h2>
      <p>
        Caffeine improved performance across many types of exercise. The effect tended to be
        larger for endurance than for short, intense efforts, and endurance was the type of
        exercise with the most consistent benefit.
      </p>
      <p>
        A dose of 3 to 6 mg per kg of body weight consistently improved performance, and lower
        doses down to about 2 mg per kg may work too. It was most often taken about an hour
        before exercise. Caffeine gum may work faster, and gels with caffeine also improved
        performance.
      </p>
      <p>
        People responded differently. Some had poor sleep or felt anxious, and how much
        caffeine you normally take may also play a part.
      </p>

      <h2>What it means for you</h2>
      <p>
        For a 70 kg runner, 3 mg per kg is about 210 mg. Start at the low end. More is not
        necessarily better, and side effects increase with the dose.
      </p>
      <p>
        Try it before a long run or a hard session first, never for the first time on race day.
        For a late race or an evening session, think about your sleep afterwards. If you are
        pregnant or have a heart condition, ask your doctor first.
      </p>

      <h2>What the research can't tell you</h2>
      <p>
        Most studies included young men. Effects in women and older runners are less studied,
        and the quality of the evidence was mostly rated moderate.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training doesn't recommend supplements. If you use caffeine before a race, practise
        it before your long runs or key sessions so you know how you react.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Grgic et al. (2020), Wake up and smell the coffee: caffeine supplementation and
          exercise performance, an umbrella review of 21 published meta-analyses.{" "}
          <a href="https://doi.org/10.1136/bjsports-2018-100278">British Journal of Sports Medicine</a>.
        </li>
        <li>
          Guest et al. (2021), International Society of Sports Nutrition position stand:
          caffeine and exercise performance.{" "}
          <a href="https://doi.org/10.1186/s12970-020-00383-4">Journal of the International Society of Sports Nutrition</a>.
        </li>
      </ul>
    </>
  );
}
